import { render, staticRenderFns } from "./TranslateEvGroupForm.vue?vue&type=template&id=54c36d40&scoped=true&"
import script from "./TranslateEvGroupForm.vue?vue&type=script&lang=js&"
export * from "./TranslateEvGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslateEvGroupForm.vue?vue&type=style&index=0&id=54c36d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c36d40",
  null
  
)

export default component.exports